module.exports = __webpack_public_path__ + "media/images/haircut/sabrina@2x-aea6cd0f24bac4534dbc6c4f232f3c4d.jpg";